import { IconName } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import createConnectedButton from '../utils/createConnectedButton';
import { TIMELINE_SHORTCUT } from '../../shortcuts';
import { trackAppNavbarEvent } from '../actions';
import { getCurrentEnterpriseTimelineUrl } from '../../timeline/selectors/view';
import { showTimeline } from '../../timeline/routes';

export default createConnectedButton({
    propSelectors: {
        url: getCurrentEnterpriseTimelineUrl,
    },
    // @ts-expect-error $TSFixMeError: Parameter 'dispatch' implicitly has an 'any' type.
    actions: (dispatch, { serviceId }: $TSFixMe) => ({
        onClick: () => {
            dispatch(trackAppNavbarEvent('/commander/reservation/dashboard'));
            dispatch(showTimeline({ serviceId }));
        },
    }),
    defaultProps: {
        icon: IconName.Timeline,
        title: TextKey.Timeline,
        shortcut: TIMELINE_SHORTCUT,
    },
});
